var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Qatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#880e4f",
    d: "M21.355,5.984l-7.935,2.645l7.935,2.645l-7.935,2.645l7.935,2.645l-7.935,2.645l7.935,2.645 L13.419,24.5l7.935,2.645l-7.935,2.645l7.935,2.645l-7.935,2.645l7.935,2.645l-7.935,2.645l7.935,2.645l-1.841,0.46 C20.958,43.808,22.455,44,24,44c11.046,0,20-8.954,20-20c0-11.046-8.954-20-20-20c-2.229,0-4.366,0.38-6.368,1.053L21.355,5.984z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M13.419,40.371l7.935-2.645l-7.935-2.645l7.935-2.645l-7.935-2.645l7.935-2.645L13.419,24.5 l7.935-2.645l-7.935-2.645l7.935-2.645l-7.935-2.645l7.935-2.645l-7.935-2.645l7.935-2.645l-3.723-0.931C9.712,7.715,4,15.183,4,24 c0,9.501,6.631,17.437,15.513,19.476l1.841-0.46L13.419,40.371z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Qatar);
export default __webpack_public_path__ + "static/media/icons8-qatar.2c46a6ad9763cfe1922542176067afd9.svg";
export { ForwardRef as ReactComponent };